import template from "./verpackung-list-page.html.twig";

Packlab.Component.register('verpackung-list-page', {
    template,


});